import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectFolderConfig } from '../select-folder/select-folder.component';
import { StorageItem } from '@uploadcam/common';

export interface SelectFoldersDialogInput {
  title: string;
  config: SelectFolderConfig;
}

export type SelectFoldersDialogResult = StorageItem[] | undefined;

@Component({
  selector: 'app-select-folders-dialog',
  templateUrl: './select-folders-dialog.component.html',
  styleUrl: './select-folders-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectFoldersDialogComponent {
  // `app-select-folder` requires a `createFolder$` input; creating folders is
  // not offered while multi-picking, so this observable never emits.
  protected readonly createFolder$ = new Subject<void>();
  protected selected: StorageItem[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) protected readonly data: SelectFoldersDialogInput,
    private readonly dialogRef: MatDialogRef<
      SelectFoldersDialogComponent,
      SelectFoldersDialogResult
    >,
  ) {}

  protected selectionChanged(folders: StorageItem[]): void {
    this.selected = folders;
  }

  protected select(): void {
    this.dialogRef.close(this.selected);
  }
}
